<template>
  <div :class="$mq" class="four-field-frame pb-4 mb-4">

    <!-- nelikenttä -->
    <div class="four-field relative noselect">
      <!-- nelikentän solut -->
      <div v-if="$route.params.topic_id === 'ketteran-kaupungin-skenaariot-2030'" class="vtt-bg opacity-9">
        <div v-if="currentField === 1" style="background-image: url(/images/siirtolapuutarha.jpg);"></div>
        <div v-else-if="currentField === 2" style="background-image: url(/images/tori.jpg);"></div>
        <div v-else-if="currentField === 3" style="background-image: url(/images/urheilukentta.jpg);"></div>
        <div v-else-if="currentField === 4" style="background-image: url(/images/lentokentta.jpg);"></div>
      </div>
      <!-- nelikentän solut -->
      <!-- <div @click="currentField = 1" :class="{ active: currentField === 1}" class="four-one break-word"><span>{{ this.data.four1 }}</span></div>
      <div @click="currentField = 2" :class="{ active: currentField === 2}" class="four-two break-word"><span>{{ this.data.four2 }}</span></div>
      <div @click="currentField = 3" :class="{ active: currentField === 3}" class="four-three break-word"><span>{{ this.data.four3 }}</span></div>
      <div @click="currentField = 4" :class="{ active: currentField === 4}" class="four-four break-word"><span>{{ this.data.four4 }}</span></div> -->
      <div @click="currentField = 1" :class="{ active: currentField === 1}" class="four-one break-word"><span v-html="data.four1"></span></div>
      <div @click="currentField = 2" :class="{ active: currentField === 2}" class="four-two break-word"><span v-html="data.four2"></span></div>
      <div @click="currentField = 3" :class="{ active: currentField === 3}" class="four-three break-word"><span v-html="data.four3"></span></div>
      <div @click="currentField = 4" :class="{ active: currentField === 4}" class="four-four break-word"><span v-html="data.four4"></span></div>

      <!-- nelikentän akseleiden määritteet (ylä, ala, vas, oik) -->
      <!-- <div class="four-top">{{ this.data.descrTop }}</div> -->
      <div v-html="data.descrTop" class="four-top"></div>
      <!-- <div class="four-bottom">{{ this.data.descrBottom }}</div> -->
      <div v-html="data.descrBottom" class="four-bottom"></div>
      <div class="four-left flex flex-center" style="white-space: nowrap;">
        <!-- <span>{{ this.data.descrLeft }}</span> -->
        <span v-html="data.descrLeft"></span>
      </div>
      <div class="four-right flex flex-center" style="white-space: nowrap;">
        <!-- <span>{{ this.data.descrRight }}</span> -->
        <span v-html="data.descrRight"></span>
      </div>

      <!-- nelikentän akselit -->
      <div class="four-field-axel-x absolute bg-black tl-50 center-xy opacity-7" style="height: 2px; width: calc(100% - (2 * 30px));">
        <i class="left material-icons">expand_less</i>
        <i class="right material-icons">expand_more</i>
      </div>
      <div class="four-field-axel-y absolute bg-black tl-50 center-xy opacity-7" style="width: 2px; height: calc(100% - (2 * 30px));">
        <i class="top material-icons">expand_less</i>
        <i class="bottom material-icons">expand_more</i>
      </div>
    </div>

    <!-- vaihtuva tekstisisältö / artikkelit -->
    <div class="text-content-html mt-4">
      <div v-if="currentField === 1" v-html="data.fourMainInfo1"></div>
      <div v-else-if="currentField === 2" v-html="data.fourMainInfo2"></div>
      <div v-else-if="currentField === 3" v-html="data.fourMainInfo3"></div>
      <div v-else-if="currentField === 4" v-html="data.fourMainInfo4"></div>
    </div>

  </div>
</template>

<script>
export default {
  props: {
    data: {
      type: Object
    }
  },

  data () {
    return {
      currentField: 0
    }
  }
}
</script>

<style lang="scss">
@import "@/styles/styles.scss";

.four-field {
  margin: 0 auto;
  max-width: 700px;
  //min-width: 350px;
  //max-width: 450px;
  min-height: 400px;
  display: grid;
  grid-template-columns: 40px 1fr 1fr 40px;
  grid-template-rows: 40px 1fr 1fr 40px;
  /* grid-template-columns: minmax(16px, 32px) 1fr 1fr minmax(16px, 32px);
  grid-template-rows: minmax(16px, 32px) 1fr 1fr minmax(16px, 32px); */
  grid-template-areas:
    ". top top ."
    "left one two right"
    "left three four right"
    ". bottom bottom .";
  grid-gap: 5px;
  .tablet & { min-height: 330px; }
  .phone & {
    margin: 0 -30px;
    min-height: 250px;
  }
  & > div {
    display: flex;
    justify-content: center;
    align-items: center;
    //border-radius: 2px;
    text-align: center;
  }
  & .active { color: $color-theme2 }
  .vtt-bg {
    grid-column: 2/4;
    grid-row: 2/4;
    position: relative;
    pointer-events: none;
    div {
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      // background-color: pink;
      background-size: cover;
      background-position: center center;
      background-repeat: no-repeat;
    }
  }
}

// nelikentän solut
.four-one { grid-area: one; }
.four-two { grid-area: two; }
.four-three { grid-area: three; }
.four-four { grid-area: four; }

.four-one,
.four-two,
.four-three,
.four-four {
  position: relative;
  cursor: pointer;
  padding: 0.8rem 0.2rem;
  //background-color: $color-theme;
  font-size: 1.1rem;
  font-weight: 700;
  //color: white;
  &:hover { background-color: rgba(0, 0, 0, 0.035); }
  .phone & { font-size: 0.9rem; }
  .tablet & { font-size: 1.05rem; }
  span {
    border-radius: 2px;
    padding: 0 0.2rem;
    background-color: rgba(255, 255, 255, 0.6);
  }
  &.active span { background-color: rgba(255, 255, 255, 0.8); }
}

// x- ja y-akseleiden selitteet
.four-top,
.four-bottom,
.four-left,
.four-right {
  //padding: 2rem;
  font-size: 0.85rem;
  pointer-events: none;
  line-height: 1rem;
  color: rgb(92, 92, 92);
  .phone & { font-size: 0.75rem; }
}
.four-top {
  grid-area: top;
  padding-bottom: 1rem;
}
.four-bottom {
  grid-area: bottom;
  padding-top: 1rem;
}
.four-left {
  grid-area: left;
  position: relative;
  padding-right: 1rem;
  span {
    position: absolute;
    -webkit-transform: rotate(-90deg); /* Safari */
    -moz-transform: rotate(-90deg); /* Firefox */
    -ms-transform: rotate(-90deg); /* IE */
    -o-transform: rotate(-90deg); /* Opera */
    transform: rotate(-90deg);
    filter: progid:DXImageTransform.Microsoft.BasicImage(rotation=3);/* Internet Explorer */
  }
}
.four-right {
  grid-area: right;
  position: relative;
  padding-left: 1rem;
  span {
    position: absolute;
    -webkit-transform: rotate(90deg); /* Safari */
    -moz-transform: rotate(90deg); /* Firefox */
    -ms-transform: rotate(90deg); /* IE */
    -o-transform: rotate(90deg); /* Opera */
    transform: rotate(90deg);
    filter: progid:DXImageTransform.Microsoft.BasicImage(rotation=1);/* Internet Explorer */
  }
}

.four-field-axel-x,
.four-field-axel-y {
  i {
    position: absolute;
    //color: #b8b8b8;
    color: black;
  }
}
.four-field-axel-x {
  .left {
    left: 0;
    top: 1px;
    transform: translate(calc(-50% + 2px), -50%) rotate(-90deg);
  }
  .right {
    right: 0;
    top: 1px;
    transform: translate(calc(50% - 2px), -50%) rotate(-90deg);
  }
}
.four-field-axel-y {
  .top {
    top: 0;
    left: 1px;
    transform: translate(-50%, calc(-50% + 2px));
  }
  .bottom {
    bottom: 0;
    left: 1px;
    transform: translate(-50%, calc(50% - 2px));
  }
}
</style>
